import React from 'react'
import ListPage from './list'
import ViewPage from './view'
import FormPage from './form'
import Services from 'mpm-services';
import * as Constans from 'mpm-config/Constants'
import Components from 'mpm-components'
import Utilities from 'mpm-config/Utilities';
import { toClasses } from 'class-converter';
import CessionExport from 'mpm-classes/CessionExport';

const searchCretariaInit = {
    numeroCessionComplet: "",
    etat: "",
    dateCessionDu: "",
    dateCessionAu: "",
    refDpmValid: ""
};

const refInitial = {
    loading: true,
    error: false,
    data: []
}

export default (props) => {
    const [searchData, setSearchData] = React.useState(searchCretariaInit);
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [pagination, setPagination] = React.useState({ page: Constans.DEFAULT_TABLE_PAGE, size: Constans.DEFAULT_TABLE_ROWS, totalPages: 1, });
    const [message, setMessage] = React.useState(null);
    const [pageVisibility, setPageVisibility] = React.useState({ showList: true, showForm: false, showView: false })
    const [selectedCessionExportId, setSelectedCessionExportId] = React.useState(null);
    const [modalData, setModalData] = React.useState({ open: false });
    const [entities, setEntities] = React.useState(refInitial)
    const [pays, setPays] = React.useState(refInitial)
    const [typesTransformations, setTypesTransformations] = React.useState(refInitial)
    React.useEffect(() => {
        Promise.all([Services.Refs.getAllEntities(), Services.Refs.getAllPays(), Services.Refs.getAllTypesTransformation()])
            .then(([resultEntities, resultPays, resultTypesTrans]) => {
                setPays({
                    loading: false,
                    data: resultPays.data,
                    error: false
                })
                setEntities({
                    loading: false,
                    data: resultEntities.data,
                    error: false
                })
                setTypesTransformations({
                    loading: false,
                    data: resultTypesTrans.data,
                    error: false
                })
            }).catch(err => {
                setPays({
                    loading: false,
                    error: true,
                    data: []
                })
                setEntities({
                    loading: false,
                    error: true,
                    data: []
                })
                setTypesTransformations({
                    loading: false,
                    error: true,
                    data: []
                })
            })

    }, [])
    const onReset = () => {
        setPagination({
            page: Constans.DEFAULT_TABLE_PAGE,
            size: Constans.DEFAULT_TABLE_ROWS,
            totalPages: 1,
        });
        setMessage(null);
        setSearchData(searchCretariaInit);
        setData([])
    };
    const loadData = (page, criteria) => {
        setLoading(true);
        let pagetoselect = page ? page - 1 : pagination.page - 1;
        Services.CessionsExportDataService.findAllPaginated(
            pagination.size,
            pagetoselect,
            !criteria ? searchData : criteria
        )
            .then((response) => {
                setData([]);
                setTimeout(() => {
                    setData(toClasses(response.data, CessionExport))
                }, 100);
                setPagination({
                    page: response.page + 1,
                    size: response.size,
                    totalPages: response.totalPages,
                });
                setMessage({
                    info: true,
                    header: "Résultat de recherche",
                    content: `${response.total} occurence(s) trouvée(s) correspondante(s) à vos critères de recherche`,
                });
                setLoading(false);
            })
            .catch((err) => {
                setData([]);
                setMessage({
                    error: true,
                    header: "Erreur lors de communication avec le serveur",
                    content: `Une erreur est survenue lors de communication avec le serveur. Veuillez réessayer ou contactez l'administrateur.`,
                });
                setLoading(false);
            })
            .finally();
    };

    const onUpdateSearch = (newSearch) => {
        setSearchData(newSearch)
    }

    const onSearch = () => {
        setMessage(null)
        loadData(pagination.page)
    }

    const onAddForm = () => {
        setSelectedCessionExportId(null)
        setMessage(null)
        setPageVisibility({ showForm: true, showList: false, showView: false })
    }

    const onViewForm = (idForm) => {
        setMessage(null)
        setSelectedCessionExportId(idForm);
        setPageVisibility({ showForm: false, showList: false, showView: true })
    }

    const onEditForm = (idForm) => {
        setMessage(null)
        setSelectedCessionExportId(idForm);
        setPageVisibility({ showForm: true, showList: false, showView: false })
    }

    const onComplet = (forceReload = false, criteria) => {
        setMessage(null)
        setPageVisibility({ showForm: false, showList: true, showView: false });
        if (forceReload && !criteria) {
            onSearch();
        } else if (criteria) {
            setSearchData({ ...searchCretariaInit, ...criteria })
            setData([])
            loadData(Constans.DEFAULT_TABLE_PAGE, { ...searchCretariaInit, ...criteria });
        }
    }

    const onDeleteForm = (row) => {
        setModalData({ ...modalData, loadingConfirm: true })
        Services.CessionsExportDataService.delete({ id: row.id, etat: row.etat })
            .then(result => {
                if (result.data.success) {
                    setMessage({
                        success: true,
                        header: "Suppression de cession export",
                        content: "Opération éffectuée avec succées!"
                    });
                    setData([])
                    setTimeout(() => {
                        setData([...data.filter(cession => cession.id !== row.id)])
                    }, 100);
                } else {
                    setMessage({
                        warning: true,
                        header: "Suppression de cession export",
                        content: result.data.message
                    });
                }
                setModalData({ open: false })
            }).catch(error => {
                setModalData({ open: false })
                setMessage({
                    error: true,
                    header: "Suppression de cession export",
                    content: "Une erreur est survenue !!"
                })
            })
    }
    const onClickBreadCrumbItem = (item) =>{
        if(item === "Demandes Export"){
            setPageVisibility({ showForm: false, showList: true, showView: false });
        }
      }

    return (
        <>
            <Components.Regions.BreadCrumb
                onClickItem={(item) => onClickBreadCrumbItem(item)}
                data={Utilities.getBreadCrumbData(["Demandes Export"],
                    pageVisibility.showForm && "Formulaire",
                    pageVisibility.showView && "Consultation",
                    pageVisibility.showList && "Recherche")} size="tiny" />
            {message && <Components.Message {...message} onClose={() => setMessage(null)} />}
            {
                pageVisibility.showList && <ListPage data={data} loading={loading} searchData={searchData} pagination={pagination}
                    entities={entities}
                    onPageChange={(activePage) => loadData(activePage)}
                    onClickAdd={() => onAddForm()}
                    onClickView={(id) => onViewForm(id)}
                    onClickEdit={(id) => onEditForm(id)}
                    onClickReset={() => onReset()}
                    onClickSearch={() => onSearch()}
                    updateSearchData={(data) => onUpdateSearch(data)}
                    onClickDelete={(row) => setModalData({ data: row, open: true, title: "Confirmation de supression", content: "Êtes vous sur de bien vouloir supprimer cette cession d'export ?", loadingConfirm: false })}
                />
            }

            {pageVisibility.showForm && <FormPage entities={entities} pays={pays} typesTransformations={typesTransformations} setMessage={setMessage} selectedCessionExportId={selectedCessionExportId} onComplet={(forcer, criteria) => onComplet(forcer, criteria)} />}

            {pageVisibility.showView && <ViewPage entities={entities} pays={pays} setMessage={setMessage} selectedCessionExportId={selectedCessionExportId} onComplet={(forcer, criteria) => onComplet(forcer, criteria)} />}

            {modalData && <Components.Modals.Confirmation modalData={modalData} onConfirm={(data) => onDeleteForm(data)} onCancel={() => setModalData({ open: false })} />}
        </>

    )
}
